import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { AuthService } from 'app/shared/auth/auth.service';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reference',
  templateUrl: './reference.component.html',
  styleUrls: ['./reference.component.scss',"../../../../../../assets/sass/libs/datatables.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ReferenceComponent implements OnInit {

    // @Input() friendsList: any = []
    @Input() referralId:any
      @Input() friendCircleList: any = []
    // @Input() connectedfriendsList: any = []
    // @Input() notConnectedfriendList: any = []
    baseUrl = environment.apiUrls.baseUrl;
    referalLink:any
    addOrInvite = "invite"
    copyLinkText:string = 'Copy link'
    refreshLinkText:string = 'Refresh link'
    pauseText: string = "Pause link";
    isRotate: boolean;
    @Input() isLoaded :boolean = false;
    @Output() refreshregenerateLink: EventEmitter<any> = new EventEmitter();
    // @Input() user: any
    user:any
    inviteObj: any = {
      name: '',
      addedBy: '',
      is_trusted:true
  }
    rows = []
    public ColumnMode = ColumnMode;
    course_data:any
    constructor(
      private api: ApiService,
      private toast: ToastrService,
      private authService: AuthService,
      private modalService: NgbModal,
      ) {
      this.user = this.authService.userValue;
      this.inviteObj.addedBy = this.user?.id;
      this.referralId = this.user.refrence_id
    }
  
    ngOnInit(): void {
      this.referalLink = `${this.baseUrl}/connect-to-learn?ref=${this.referralId}`
      this.pauseText = this.friendCircleList.invitedIdActivated ? 'Pause link' : 'Link paused'
      this.getReferenceUsers(this.user.id)
  }
  
  getReferenceUsers(id) {
    this.api.getUsersByReferenceId(id).subscribe((res: any) => {
      this.rows = res?.data
    })
  }

    regenerateLink(){
      this.isRotate = true;
      this.refreshLinkText = 'Link refreshed'
      // this.api.regenerateLink().subscribe((res: any) => {
      //   if (res.isSuccess) {
      //     this.friendCircleList = res.data;
      //     this.referralId  = this.friendCircleList.invitedId
      //     this.referalLink = `${this.baseUrl}?ref=${this.referralId}`
      //     // this.toast.success("Referral Id Refreshed")
      //     setTimeout(() => {
      //       this.refreshLinkText = 'Refresh link'
      //     }, 2000);
      //     this.isRotate = false;
      //   }
      // })
    }
    activeOrPauseLink(value){
      // this.api.activeOrPauseLink(value).subscribe((res) => {
      //   if (res.isSuccess) {
      //     this.refreshregenerateLink.emit();
      //   }
      // })
      if(value){
            this.pauseText = "Pause link";
      }else{
        // this.toast.success("Link Paused")
        this.pauseText="Link paused";
      }
    }
    copyText(text) {
      navigator.clipboard.writeText(text).then().catch(e => console.error(e));
  }
    copyLink() {
      this.copyLinkText = 'Link copied'
      this.copyText(this.referalLink)
      setTimeout(() => {
        this.copyLinkText = 'Copy link'
      }, 2000);
      this.toast.success("Link copied")
    }
  
    genericSocialShare(provider) {
      let url: string;
      let subject = "You're invited! Please join me on Meander Software to explore the learning activities nearby:";
      let emailSubject = "You're invited! Please join me on Meander Software to explore the learning activities nearby:"
      let emailBody = "You're invited! Please join me on Meander Software to explore the learning activities nearby!"
      switch (provider) {
        case 'facebook': {
          const encodedLink = encodeURIComponent(this.referalLink);
          const encodedSubject = encodeURIComponent(subject);
          url = `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}&quote=${encodedSubject}`;
          window.open(url, 'sharer', 'toolbar=0,status=0,width=648,height=395');
          return true;
        }
        case 'email': {
          const encodedLink = encodeURIComponent(this.referalLink);
          navigator.clipboard.writeText(this.referalLink).then().catch(e => console.error(e));
          url = `mailto:?subject=${emailSubject}&body=${emailBody} ${encodedLink}`;
          window.open(url, 'sharer', 'toolbar=0,status=0,width=648,height=395');
          return true;
        }
        case 'whatsapp': {
          url = `https://api.${provider}.com/send?text=${subject} ${this.referalLink}`;
          window.open(url, 'sharer', 'toolbar=0,status=0,width=648,height=395');
          return true;
        }
  
        case 'messenger': {
          const encodedLink = encodeURIComponent(this.referalLink);
          const encodedSubject = encodeURIComponent(subject);
          const facebookShareLink = `https://www.facebook.com/dialog/send?app_id=896910040882234&link=${encodedLink}&redirect_uri=${this.baseUrl}&message=${encodedSubject}`;
          window.open(facebookShareLink, 'sharer', 'toolbar=0,status=0,width=1000,height=600');
          return true;
        }
        
        
        case 'instagram': {
          window.open(`https://www.${provider}.com/share?url=${this.referalLink}`, 'sharer', 'toolbar=0,status=0,width=648,height=395');
          return true;
        }
        default: {
          console.error('Unsupported social media provider:', provider);
          return false;
        }
  
      }
  }
  openModalNotes(content,data) {
        this.course_data=data
        const modalOptions: NgbModalOptions = {
          backdrop: 'static', // Set backdrop to 'static' to prevent closing on clicking outside
          keyboard: false,    // Set keyboard to false to prevent closing on pressing Escape key
        };
        const modalRef = this.modalService.open(content,modalOptions);
        modalRef.result.then((result) => {
          // console.log(`Modal closed with result: ${result}`);
        }, (reason) => {
          // console.log(`Modal dismissed with reason: ${reason}`);
        });
      }
  }
  